import { render, staticRenderFns } from "./CreateHandlingHeader.vue?vue&type=template&id=5e5bcfbe"
import script from "./CreateHandlingHeader.vue?vue&type=script&lang=js"
export * from "./CreateHandlingHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports